<div class="email-digest-actions" kendoTooltip tooltipClass="tooltip-adjust-right">
    <kendo-switch onLabel="ON" offLabel="OFF" [(ngModel)]="item.isSubscribed" (click)="switchSubscription($event)"
        [disabled]="!item.isSubscribable || !item.active" title="Subscribe/Unsubscribe"></kendo-switch>
    &nbsp;&nbsp;&nbsp;
    <smart-icon name="preview" class="light" [class.disabled]="isDashboardType" (click)="preview($event)"
        title="Preview"></smart-icon>
    <div (click)="showContextMenu($event)">
        <smart-icon name="meatball" class="light"></smart-icon>
    </div>
</div>